// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navSideBar {
  position: relative;
  flex: 0 0 200px;
  flex-direction: column;
  display: flex;
  max-width: 200px;
  height: 100%;
}

.navSideBarInput {
  flex: 0 0 auto;
  padding: 2px 8px;
}

.navSideBarInput input {
  padding: 4px 2px;
  border: none;
  border-bottom: 1px solid var(--color-light-grey);
  width: 80%;
}

.navItems {
  flex: 1 1 auto;
  overflow: auto;
}

.navItemGroup {
  font-weight: 600;
  margin-top: 12px;
  padding: 0px 8px;
}


.navNotFound {
  padding: 10px 8px;
  font-size: 9pt;
  color: var(--color-grey);
  width: 80%;
}
`, "",{"version":3,"sources":["webpack://./src/components/NavigationSideBar/style.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gDAAgD;EAChD,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;;AAGA;EACE,iBAAiB;EACjB,cAAc;EACd,wBAAwB;EACxB,UAAU;AACZ","sourcesContent":[".navSideBar {\n  position: relative;\n  flex: 0 0 200px;\n  flex-direction: column;\n  display: flex;\n  max-width: 200px;\n  height: 100%;\n}\n\n.navSideBarInput {\n  flex: 0 0 auto;\n  padding: 2px 8px;\n}\n\n.navSideBarInput input {\n  padding: 4px 2px;\n  border: none;\n  border-bottom: 1px solid var(--color-light-grey);\n  width: 80%;\n}\n\n.navItems {\n  flex: 1 1 auto;\n  overflow: auto;\n}\n\n.navItemGroup {\n  font-weight: 600;\n  margin-top: 12px;\n  padding: 0px 8px;\n}\n\n\n.navNotFound {\n  padding: 10px 8px;\n  font-size: 9pt;\n  color: var(--color-grey);\n  width: 80%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navSideBar": `navSideBar`,
	"navSideBarInput": `navSideBarInput`,
	"navItems": `navItems`,
	"navItemGroup": `navItemGroup`,
	"navNotFound": `navNotFound`
};
export default ___CSS_LOADER_EXPORT___;
